theme.JelenewAiFace = new (function () {
  this.onSectionLoad = function (container) {
    // jelenewSectionAppendTemplate(".jelenew-ai-face-template", container);
    var $container=$(container);
    const _this = this;
    var head_img=""; //人脸图
    var source_img="";//原图
    // var aiface_list='';//生成的ai图片列表
    var aiface_image="";
    if (window.Swiper) {
      var swiper = new Swiper(".aiFaceSwiper", {
        effect: "cards",
        grabCursor: true,
        loop: true,
        centeredSlides: true,
        initialSlide:2,
        rotate:true,
        mousewheel:{invert:false},
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    }
    window.jelenew.functions.uploadImgAction(container, _this,1,true);
    aiFaceImgList()
    $(".jelenew-ai-face-swiper .jelenew-ai-face-img-btn",container).css("pointer-events","auto");
    //ios 图片下载提示
    if (window.innerWidth < 767){
      if (navigator.userAgent.match(/(iPhone|iPod|iPad)/)) {
          $(".jelenew-ai-face-modal-container.ai-success .btn.ai-download",container).text("Complete");
        $(".jelenew-ai-face-modal-container.ai-success .tips",container).show();
        $(".jelenew-ai-face-modal-container.ai-success .btn.ai-download",container).css("margin-top","30px");
      }
    }

    // 点击打开弹窗
    $(container).on("click", ".jelenew-ai-face-swiper .aiFaceSwiper,.jelenew-ai-face-swiper .jelenew-ai-face-img-btn,.jelenew-ai-face-modal-container.ai-success .ai-face-new,.jelenew-ai-face-modal-container.face-send .face-send-btn", function () {
      $(".jelenew-ai-face-modal-container.ai-success",container).hide()
      $(".jelenew-ai-face-modal-container.face-send",container).hide()
      $(".jelenew-ai-face-modal-container.upload-image",container).show()
      
      //获取头像缓存
      head_img=localStorage.getItem("jelenew_aiface_swapUrl");
      // 获取原图
      source_img=$(".jelenew-ai-face-swiper .aiFaceSwiper .swiper-slide.swiper-slide-active",container).data("ai-image");
      //上传头像按钮生效
      $(".jelenew-ai-face-modal-content .btn.ai-head",container).css("pointer-events","auto");
      if(head_img){
        $(".jelenew-ai-face-modal-content .modal-content .image-head .jelenew-upload-loading",container).hide();
        $(".jelenew-ai-face-modal-content .btn.ai-head",container).hide();
        $(".jelenew-ai-face-modal-content .btn.ai-face",container).css('display','flex');
        $(".jelenew-ai-face-modal-content .ai-tips",container).show();
        $(".jelenew-ai-face-modal-content .modal-content .tips",container).hide();
        $(".jelenew-ai-face-modal-content .modal-content .image-head",container).show();
        $(".jelenew-ai-face-modal-content .modal-content .image-feng-mian",container).hide();
        $(".jelenew-ai-face-modal-content .modal-content .image-head",container).find("img").attr("src", head_img);
      }else{
        $(".jelenew-ai-face-modal-content .modal-content .image-feng-mian",container).show();
        $(".jelenew-ai-face-modal-content .modal-content .tips",container).show();
  
        $(".jelenew-ai-face-modal-content .modal-content .image-head",container).hide();
        $(".jelenew-ai-face-modal-content .modal-content .image-head .jelenew-upload-loading",container).show();
  
        $(".jelenew-ai-face-modal-content .btn.ai-head",container).css('display','flex');
        $(".jelenew-ai-face-modal-content .btn.ai-face",container).hide();
        $(".jelenew-ai-face-modal-content .ai-tips",container).hide();
      }
      $(".jelenew-ai-face-modal",container).show();
      
      //获取ai头像缓存 根据数量判断按钮状态
      let aiface_list=JSON.parse(localStorage.getItem("jelenew_ai_face_List")) || [];
      if(aiface_list.length > 0){
        $(".jelenew-ai-face-modal-content .btn.ai-face span",container).text("("+aiface_list.length+"/3)");
        if(aiface_list.length >= 3){
          $(".jelenew-ai-face-modal-content .btn.ai-face",container).css("pointer-events","none");
        }
      }
    })

    // 关闭弹窗
    $(container).on("click", ".jelenew-ai-face-modal .jelenew-ai-face-modal-close", function () {
      $(".jelenew-ai-face-modal",container).hide();
      $(".jelenew-ai-face-modal-container.upload-image",container).hide()
      $(".jelenew-ai-face-modal-container.face-send",container).hide()
      $(".jelenew-ai-face-modal-container.ai-success",container).hide()
      $(".jelenew-ai-face-modal-container.ai-ins-share",container).hide()
    })

    // 上传图片开始调用 可以传递参数
    window.imageUploadStart = function (options = {}) {
      return $.Event("theme:imageUpload.start", Object.assign({ bubbles: true, cancelable: false }, options));
    };
    $(document).on("theme:imageUpload.start", function(evevt) {
      //上传头像按钮失效
      $(".jelenew-ai-face-modal-content .btn.ai-head",container).css("pointer-events","none");

      $(".jelenew-ai-face-modal-content .modal-content .image-feng-mian",container).hide();
      $(".jelenew-ai-face-modal-content .modal-content .tips",container).hide();

      $(".jelenew-ai-face-modal-content .modal-content .image-head",container).show();
      $(".jelenew-ai-face-modal-content .modal-content .image-head .jelenew-upload-loading",container).show();

      $(".jelenew-ai-face-modal-content .btn.ai-head",container).css('display','flex');
      $(".jelenew-ai-face-modal-content .btn.ai-face",container).hide();
      $(".jelenew-ai-face-modal-content .ai-tips",container).hide();
      
      $(".jelenew-ai-face-modal-content .modal-content .image-head",container).find("img").attr("src", evevt.img_url);
    })

    // 上传图片结束调用
    $(document).on("theme:imageUpload.end", function() {
        //获取上传头像
      const mediaList = Array.from(_this.mediaMap.values());
      head_img=mediaList.join(",");
      $(".jelenew-ai-face-modal-content .modal-content .image-head .jelenew-upload-loading",container).hide();
      $(".jelenew-ai-face-modal-content .btn.ai-head",container).hide();
      $(".jelenew-ai-face-modal-content .btn.ai-face",container).css('display','flex');
      $(".jelenew-ai-face-modal-content .ai-tips",container).show();
      //上传头像按钮生效
      $(".jelenew-ai-face-modal-content .btn.ai-head",container).css("pointer-events","auto");
      //设置头像缓存
      localStorage.setItem("jelenew_aiface_swapUrl", head_img);
    });

    // 点击关闭头像
    $(container).on("click", ".jelenew-ai-face-modal-content .modal-content .image-head .jelenew-upload-img-close", function () {
      //上传头像按钮生效
      $(".jelenew-ai-face-modal-content .btn.ai-head",container).css("pointer-events","auto");
      // 删除头像div
      $(".jelenew-upload-img-container:not(.hidden)", container).remove();
      //清除头像map集合为空
      _this.mediaMap.clear();
      head_img="";
      //设置头像缓存
      localStorage.setItem("jelenew_aiface_swapUrl", "");
      
      $(".jelenew-ai-face-modal-content .modal-content .image-feng-mian",container).show();
      $(".jelenew-ai-face-modal-content .modal-content .tips",container).show();

      $(".jelenew-ai-face-modal-content .modal-content .image-head",container).hide();
      $(".jelenew-ai-face-modal-content .modal-content .image-head .jelenew-upload-loading",container).show();

      $(".jelenew-ai-face-modal-content .btn.ai-head",container).css('display','flex');
      $(".jelenew-ai-face-modal-content .btn.ai-face",container).hide();
      $(".jelenew-ai-face-modal-content .ai-tips",container).hide();
    });

    //上传ai换脸
    $(container).on("click", ".jelenew-ai-face-modal-content .btn.ai-face", function () {
      //获取ai头像缓存
      let aiface_list=JSON.parse(localStorage.getItem("jelenew_ai_face_List")) || [];
      if(aiface_list.length >=3){
          return
      }
      // 关闭图片上传弹层  显示图片加载动画
      $(".jelenew-ai-face-modal-container.upload-image",container).hide()
      $(".jelenew-ai-face-modal-container.face-send",container).show()
      $(".jelenew-ai-face-modal-container.face-send .face-send-pross",container).addClass("active")
      $(".jelenew-ai-face-modal-container.face-send .face-send-noice",container).hide()
      $(".jelenew-ai-face-modal-container.face-send .face-send-btn",container).hide()
      var imageId=new Date().getTime();
      var params={
        "sourceUrl": head_img,
        "swapUrl": "https:"+source_img,
        "imageId":imageId
      }
      jelenewHttp.post("/api/shop/swap/productImg", params).then((res) => {
        if(res.status.code==0){
          aiface_list.push({
            imageId:imageId,
            url:res.result.targetImage
          });
          aiface_image=res.result.targetImage;
          $(".jelenew-ai-face-modal-container.ai-success .ai-image-show",container).find("img").attr("src",res.result.targetImage);
          $(".jelenew-ai-face-modal-container.ai-ins-share .aiface-image",container).attr("src",res.result.targetImage);
          $(".jelenew-ai-face-modal-content .btn.ai-face span",container).text("("+aiface_list.length+"/3)");
          localStorage.setItem("jelenew_ai_face_List",JSON.stringify(aiface_list));
          //删除文字
          $(".jelenew-ai-face-history-imgs-none",container).remove();
          //追加生成的图片
          var img_dom="<div class='img-slide'><img src="+res.result.targetImage+"></div>"
          $(".jelenew-ai-face-history .jelenew-ai-face-history-imgs",container).append(img_dom);
          //弹出生成图片
          $(".jelenew-ai-face-modal-container.upload-image",container).hide()
          $(".jelenew-ai-face-modal-container.face-send",container).hide()
          $(".jelenew-ai-face-modal-container.ai-success",container).show()
        }else{
          
        }

        // let sensorsParam = {
        //   element_name: "Submit",
        //   email_input: email,
        //   popup_type: customer_tag,
        //   popup_strategy: "点击触发",
        //   popup_name: "订阅弹层",
        // };
        // sensors.track("ClickLayerSubmit", sensorsParam);
      }).catch((err) => {
          $(".jelenew-ai-face-modal-container.face-send",container).show()
          $(".jelenew-ai-face-modal-container.face-send .face-send-pross",container).removeClass("active")
          $(".jelenew-ai-face-modal-container.face-send .face-send-noice",container).show()
          $(".jelenew-ai-face-modal-container.face-send .face-send-btn",container).show()
          if(err.status.code=10002){
            $(".jelenew-ai-face-modal-container.face-send .face-send-noice",container).text(err.status.desc)
            $(".jelenew-ai-face-modal-container.face-send .face-send-pross",container).hide()
            $(".jelenew-ai-face-modal-container.face-send .face-send-tips",container).hide()
          }
      });
      
    });

    // 点击历史记录，弹出下载框
    $(container).on("click", ".jelenew-ai-face-history-imgs .img-slide", function () {
      var imageUrl=$(this).find("img").attr("src");
      $(".jelenew-ai-face-modal-container.ai-success .ai-image-show",container).find("img").attr("src",imageUrl);
      $(".jelenew-ai-face-modal-container.ai-ins-share .aiface-image",container).attr("src",imageUrl);
      $(".jelenew-ai-face-modal-container.ai-success",container).show()
      $(".jelenew-ai-face-modal",container).show();
    })

    //点击下载图像
    $(container).on("click", ".jelenew-ai-face-modal-container.ai-success .ai-download", function () {
      $(this).css("pointer-events","none");
      var image = $(".jelenew-ai-face-modal-container.ai-success .ai-image-show",container).find("img").attr("src");
      var image_name=new Date().getTime();

    
      if (window.innerWidth > 768) {
        downloadImage(image,image_name)
      }else{
        // 判断是否在 iOS 环境下
        if (navigator.userAgent.match(/(iPhone|iPod|iPad)/)) {

        }else{
          downloadImage(image,image_name)
        }
      }
      $(this).css("pointer-events","auto");
      $(".jelenew-ai-face-modal-container.ai-success",container).hide()
      $(".jelenew-ai-face-modal-container.ai-ins-share",container).show()
    });
    
    function downloadImage(src, imgName) {
      src = src + "?t=" + new Date().getTime();
      fetch(src).then((response) => {
        response.blob().then((myBlob) => {
          const href = URL.createObjectURL(myBlob);
          let a = document.createElement("a");
          a.href = href;
          a.download = imgName;
          a.click();
        });
      });
      // const image = new Image()
      // // 解决跨域 Canvas 污染问题
      // image.setAttribute('crossOrigin', 'anonymous')
      // image.onload = () => {
      //   const canvas = document.createElement('canvas')
      //   canvas.width = image.width
      //   canvas.height = image.height
      //   const context = canvas.getContext('2d')
      //   context.drawImage(image, 0, 0, image.width, image.height)
      //   canvas.toBlob((blob) => {
      //     const url = URL.createObjectURL(blob)
      //     const a = document.createElement('a')
      //     a.download = imgName || 'photo'
      //     a.href = url
      //     a.click()
      //     a.remove()
      //     URL.revokeObjectURL(url)
      //   })
      // }
      // image.src = src
    }


    
    // 跟新生成的ai图片列表dom
    function aiFaceImgList(){
      let aiface_list=JSON.parse(localStorage.getItem("jelenew_ai_face_List")) || [];
      var imageIdArr=[]
      if(aiface_list.length > 0){
        //删除文字
        $(".jelenew-ai-face-history-imgs-none",container).remove();
        aiface_list.forEach((value, index) => {
          // 判断图片链接是否包含
          if(!value.url.includes("cdn.jelenew.com")){
            imageIdArr.push(value.imageId.toString());
          }
        });
        // 通过id获取图片内容
        if(imageIdArr.length>0){
          var params={
              "imageIds": imageIdArr
          }
          jelenewHttp.post("/api/shop/swap/swapImages", params).then((res) => {
            if(res.status.code==0){
              aiface_list.forEach((value, index) => {
                res.result.forEach((item, i) => {
                  console.log(item.imageId)
                  if(value.imageId==item.imageId){
                    aiface_list[index].url=item.targetImage
                  }
                });
              });
            }
          }).finally(() => {
              //追加生成的图片
              aiface_list.forEach((value, index) => {  
                let img_dom="<div class='img-slide'><img src="+value.url+"></div>"
                $(".jelenew-ai-face-history .jelenew-ai-face-history-imgs",container).append(img_dom);
              })
              localStorage.setItem("jelenew_ai_face_List",JSON.stringify(aiface_list));
          })
        }else{
          //追加生成的图片
          aiface_list.forEach((value, index) => {  
            let img_dom="<div class='img-slide'><img src="+value.url+"></div>"
            $(".jelenew-ai-face-history .jelenew-ai-face-history-imgs",container).append(img_dom);
          })
          localStorage.setItem("jelenew_ai_face_List",JSON.stringify(aiface_list));
        }
        
      }
    }



  };
})();
theme.Sections.register("jelenew-ai-face", theme.JelenewAiFace, { deferredLoad: true });